<template>
  <dv-scroll-ranking-board v-if="config.data.length" :config="config" class="board" />
</template>

<script>
import { getCourseDataApi } from '@/api/school'
export default {
  name: 'CourseStudentCount',
  data () {
    return {
      config: {
        data: []
      }
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      getCourseDataApi({ schoolId: this.schoolId }).then(res => {
        let data = res.result.map(item => {
          return {
            name: item.name,
            value: item.signCount,
          }
        })
        this.$set(this.config, 'data', data)
        setTimeout(this.getData, 600000)
      })
    },
  }
}
</script>

<style lang="less">

.board {
    width: 100%;
    height: 180px !important;
}
</style>
